module.exports = __webpack_public_path__ + "img/grey_016.32bf6012.png";